export default __webpack_public_path__ + "static/media/light-bulb-idea.55196bf5.svg";